module.exports = {
    PANEL_EXPANDED_EMIT_EVENT: 'deliverySaver:panelExpanded',
    PANEL_EXPANDED_BROADCAST_EVENT: 'deliverySaver:panelExpandedBroadcast',
    PANEL_EXPAND: 'deliverySaver:expand',
    SUBSCRIPTION_STATUS: {
        ACTIVE: 'Active',
        SUSPENDED: 'Suspended',
        CANCELLED: 'Cancelled',
    },

    PLAN_TYPE: {
        MID_WEEK: 'midweek',
        ANY_DAY: 'anyDay',
    },

    SUBSCRIBER_TYPE: {
        PERSONAL: 'Personal',
        SENIOR: 'Senior',
        BUSINESS: 'Business',
    },
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver.constants.js